import React from "react";

import "./Footer.css";

export const Footer = () => {

    return(

        <div className="row container">         
            <span>Hecho por Valentín Nicheglod | 2020</span>
        </div>

    );
};
